<div class="form-control">
    <label>{{'ORIGIN' | translate}}</label>
    <p-dropdown placeholder="Selecione..." appendTo="body" [(ngModel)]="movementLocation" [options]="movementLocations"
        emptyFilterMessage="" name="selectMovementLocationOrigin" (onChange)="selectMovementLocationOrigin($event)">
    </p-dropdown>
</div>